export default "__VITE_ASSET__DaHR3J0n__"